import { getJsonPathValue, reorderList } from '@carboncopyco/editor-utils';
import { DraggableList } from '../DraggableList';
import { FormField } from './FormField';
import type { BaseJsonForm } from './types';

export const JsonFormBuilder = ({ value, onChange }: BaseJsonForm) => {
  return (
    <DraggableList
      items={value.fields.map((field) => ({
        id: field.jsonPath,
        item: field,
      }))}
      onDragEnd={({ sourceIndex, destinationIndex }) => {
        const reorderedFields = reorderList(
          value.fields,
          sourceIndex,
          destinationIndex
        );
        onChange({ ...value, fields: reorderedFields });
      }}
      renderItem={(field) => {
        let fieldValue;
        try {
          fieldValue = getJsonPathValue(value.json, field.jsonPath);
        } catch (error) {
          console.log(error);
          return null;
        }

        return (
          <FormField
            key={field.jsonPath}
            field={field}
            value={fieldValue}
            onChangeField={(updatedField) =>
              onChange({
                ...value,
                fields: value.fields.map((field) =>
                  field.jsonPath === updatedField.jsonPath
                    ? updatedField
                    : field
                ),
              })
            }
            onRemoveField={(jsonPath) =>
              onChange({
                ...value,
                fields: value.fields.filter(
                  (field) => field.jsonPath !== jsonPath
                ),
              })
            }
            editableField
            readOnly
          />
        );
      }}
    />
  );
};
